import { render, staticRenderFns } from "./EducationalDetails.vue?vue&type=template&id=245cc7d3&scoped=true"
import script from "./EducationalDetails.vue?vue&type=script&lang=js"
export * from "./EducationalDetails.vue?vue&type=script&lang=js"
import style0 from "./EducationalDetails.vue?vue&type=style&index=0&id=245cc7d3&prod&scoped=true&lang=css"
import style1 from "./EducationalDetails.vue?vue&type=style&index=1&id=245cc7d3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245cc7d3",
  null
  
)

export default component.exports